/**
 * Created by vladislav on 04.09.2019
 */

const LanternWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, fromLevelStartWindow) {
        const styles = cleverapps.styles.LanternWindow;

        this.mission = mission;

        this._super({
            name: "lanternwindow",
            title: Messages.get("LanternWindow.Title"),
            content: this.getContent(),
            button: {
                width: styles.button.width,
                height: styles.button.height,
                text: Messages.get("Play"),
                onPressed: function () {
                    if (fromLevelStartWindow) {
                        this.close();
                        return;
                    }
                    this.close();
                    
                    cleverapps.focusManager.distract({
                        focus: "PlayButton",
                        action: function (f) {
                            Level.WantsToPlay(f);
                        }
                    });
                }.bind(this)
            },
            styles: cleverapps.styles.LanternWindow.window,
            help: bundles.lantern_guide_window && function () {
                cleverapps.focusManager.display({
                    focus: "LanternGuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow({
                            name: "LanternGuideWindow",
                            bundle: bundles.lantern_guide_window
                        });
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            }
        });
    },

    getContent: function () {
        const styles = cleverapps.styles.LanternWindow;

        const bgNode = new cc.Node();
        bgNode.setAnchorPoint(0.5, 0.5);

        const bg = new cc.Sprite(bundles.lantern_window.frames.lantern_bg_png);
        bgNode.addChild(bg);
        bgNode.setContentSize(bg.width * bg.scaleX, bg.height * bg.scaleY);
        bg.setAlignment(bgNode.width / 2, bgNode.height / 2);

        const animation = new cleverapps.Spine(bundles.lantern.jsons.lantern_json);
        bgNode.addChild(animation);
        animation.setAlignment(bgNode.width / 2 + styles.animation.x, bgNode.height / 2 + styles.animation.y);
        animation.setAnimation(0, `idle_${this.mission.logic.lantern.getCurrentStreak()}`, true);

        const bonuses = this.createBonuses();
        bgNode.addChild(bonuses);
        bonuses.setAlignment(styles.bonuses);

        const text = this.createText();
        let timer;

        if (this.mission.isRunning()) {
            timer = this.createTimer();
        }

        const items = [bgNode, text];

        bgNode.addChild(timer);
        timer.setAlignment(styles.timer);

        return new cleverapps.Layout(items, {
            margin: styles.margin,
            direction: cleverapps.UI.VERTICAL
        });
    },

    createBonuses: function () {
        const styles = cleverapps.styles.LanternWindow;

        const currentStreak = this.mission.logic.lantern.getCurrentStreak();

        const items = [];

        const boosters = cleverapps.boosters.listBoostersBefore();

        boosters.forEach((booster, index) => {
            const isActive = index < currentStreak;
            const hasArrow = index < boosters.length - 1 && styles.bonuses.arrow;

            items.push(this.createBoosterBg(booster, isActive, hasArrow));

            const bundle = bundles.lantern_window.frames;
            if (index < boosters.length - 1 && !styles.bonuses.arrow) {
                let arrowName = "lantern_arrow_off_png";
                if (isActive || !bundle[arrowName]) {
                    arrowName = "lantern_arrow_png";
                }

                const arrow = new cc.Sprite(bundle[arrowName]);

                arrow.setLocalZOrder(1);
                items.push(arrow);

                if (styles.flashingArrows) {
                    const white = cleverapps.styles.COLORS.WHITE;
                    const darkGray = cleverapps.styles.COLORS.COLOR_DARK_GRAY;

                    if (isActive) {
                        if (index + 1 === currentStreak) {
                            arrow.runAction(new cc.RepeatForever(
                                new cc.Sequence(
                                    new cc.TintTo(0.9, darkGray.r, darkGray.g, darkGray.b),
                                    new cc.DelayTime(0.1),
                                    new cc.TintTo(0.9, white.r, white.g, white.b),
                                    new cc.DelayTime(0.1)
                                )
                            ));
                        }
                    } else {
                        arrow.setColor(darkGray);
                    }
                }
            }
        });

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.bonuses.margin
        });
    },

    createBoosterBg: function (booster, isActive, hasArrow) {
        const styles = cleverapps.styles.LanternWindow;

        const bg = new cc.Scale9Sprite(isActive ? bundles.lantern_window.frames.bonus_bg_on_png : bundles.lantern_window.frames.bonus_bg_off_png);
        bg.setContentSize2(styles.bonuses.bonusBg);

        const icon = new cc.Sprite(booster.icon);
        bg.addChild(icon);

        icon.setAlignment(bg.width / 2, bg.height / 2);
        if (!isActive) {
            icon.setColor(new cc.Color(120, 120, 120, 255));
        }

        if (hasArrow) {
            const arrow = new cc.Sprite(isActive ? bundles.lantern_window.frames.bonus_arrow_on_png : bundles.lantern_window.frames.bonus_arrow_off_png);
            arrow.setAlignment(styles.bonuses.arrow);
            bg.addChild(arrow);
        }

        return bg;
    },

    createText: function () {
        const styles = cleverapps.styles.LanternWindow;

        // eslint-disable-next-line no-restricted-syntax
        const text = cleverapps.UI.generateTTFText(Messages.get("LanternWindow.text"), styles.text.font);
        text.setDimensions(styles.text.width, 0);
        text.fitTo(undefined, styles.text.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        return text;
    },

    createTimer: function () {
        return new Timer(this.mission.getTimeLeft(), this.close.bind(this), {
            font: cleverapps.styles.LanternWindow.timer.font,
            timerBg: bundles.lantern_window.frames.timer_bg_png,
            timerIcon: bundles.lantern_window.frames.timer_png
        });
    },

    listBundles: function () {
        return ["lantern_window"];
    }
});

LanternWindow.BONUSES_ORDER = {
    "heroes": 0,
    "moves": 1,
    "multicolor": 2
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LANTERN_WINDOW_TEXT: {
        size: 33,
        color: new cc.Color(130, 70, 40, 255)
    },
    LANTERN_WINDOW_AMOUNT_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            size: 2,
            color: cleverapps.styles.COLORS.BLACK
        }
    }
});

cleverapps.styles.LanternWindow = {
    margin: 30,
    timer: {
        x: { align: "center" },
        y: { align: "top", dy: 15 },
        bg: {
            width: 215,
            height: 65
        }
    },
    text: {
        height: 400,
        width: 600,
        font: cleverapps.styles.FONTS.LANTERN_WINDOW_TEXT
    },
    button: {
        width: 220,
        height: 110
    },
    animation: {
        x: 0,
        y: 58
    },
    bonuses: {
        x: { align: "center" },
        y: { align: "bottom", dy: 5 },
        bonusBg: {
            width: 180,
            height: 180
        },
        offsetY: 5,
        margin: -23,
        amount: {
            x: { align: "right", dx: -28 },
            y: { align: "bottom", dy: 17 }
        },
        arrow: undefined
    }
};